import BaseInput from './input';

const BaseNameField = BaseInput.extend({
    name: 'name-field',
    fieldName: 'name'
});

export default BaseNameField;



// WEBPACK FOOTER //
// ./registration/static_source/js/registration/base/fields/name.js